import moment from "moment";

export const generatePaymentContractActivityStatus = paymentContract => {
    if (!paymentContract) {
        return null;
    }

    const {status, startDate, isActive = false} = paymentContract;

    //ileri tarihli bir sözleşme varsa
    const isFutureContract = startDate ? moment(startDate).isAfter(moment()) : false;

    const activityStatus = isActive
        ? "active"
        : status === "cancelled"
        ? "cancelled"
        : isFutureContract
        ? "future"
        : "inactive";

    return activityStatus;
};
